







































































import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
import {Icon} from "@/helpers/icons";
import {enumTextFromValue} from "@/helpers/functions_asi";
import CompanyModel from "@/models/company/Company";
import {CompanyState, CompanyType, Permissions} from "@/helpers/constants";
import AsiTabs from "@/components/common/AsiTabs";
import AsiMenuItem from "@/components/common/AsiMenuItem.vue";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import AsiConfirmDialog from "@/components/common/AsiConfirmDialog.vue";
import CompanyTabDetails from "@/components/company/CompanyTabDetails.vue";
import CompanyTabUsers from "@/components/company/CompanyTabUsers.vue";
import CompanyTabReports from "@/components/company/CompanyTabReports.vue";
import CompanyTabBills from "@/components/company/CompanyTabBills.vue";
import CompanyTabOrders from "@/components/company/CompanyTabOrders.vue";
import CompanySimple from "@/models/company/CompanySimple";
import AsiDialogAvatarUpload from "@/components/common/AsiDialogAvatarUpload.vue";
import UserCreateDialog from "@/components/user/UserCreateDialog.vue";
import OrderCreateDialog from "@/components/order/OrderCreateDialog.vue";
import ReportCreateDialog from "@/components/report/ReportCreateDialog.vue";
import BillCreateDialog from "@/components/bill/BillCreateDialog.vue";

@Component({
	components: {
		BillCreateDialog,
		OrderCreateDialog,
		ReportCreateDialog,
		UserCreateDialog,
		AsiDialogAvatarUpload,
		CompanyTabOrders,
		CompanyTabBills,
		CompanyTabReports,
		CompanyTabUsers,
		CompanyTabDetails,
		AsiConfirmDialog,
		AsiMenuItem,
		AsiTabs,
		AsiPageTitle
	}
})
export default class Company extends Vue {

	@Prop({type: String, required: true})
	public id!: string;

	private icons = Icon;
	private company: CompanyModel | null = null;
	private activeTab: number = 0;
	private loading: boolean = false;
	private avatarDialogOpen: boolean = false;
	private billCreateDialogOpen: boolean = false;
	private userCreateDialogOpen: boolean = false;
	private reportCreateDialogOpen: boolean = false;
	private orderCreateDialogOpen: boolean = false;

	private get companyArchived(): boolean {
		return this.company?.state === CompanyState.archived ?? true;
	}

	private get companyName(): string {
		if (this.company === null) return '';
		return this.company.name;
	}

	private get companyType(): string {
		if (this.company === null) return '';
		return enumTextFromValue(CompanyType, this.company.type, true) ?? '';
	}

	private get hasReports(): boolean {
		return this.company?.hasReports ?? true;
	}

	private get isAdmin(): boolean {
		return this.$store.getters['user/isAdmin'];
	}

	private get isInternal(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightInternal);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isOwnCompany(): boolean {
		const loggedInUserCompany = this.$store.state.user.loggedInUserCompany;
		if (this.company === null || loggedInUserCompany === null) return false;
		return this.company.id === loggedInUserCompany.id;
	}

	private get avatarUrl(): string | null {
		return CompanySimple.avatarUrlMedium(this.company);
	}

	public mounted(): void {
		this.loadCompany();
	}

	private loadCompany(): void {
		this.loading = true;
		this.$companyService.company(this.id)
			.then(company => {
				this.company = company;
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => {
				this.loading = false;
			});
	}

	private setStateActive(): void {
		this.setState(CompanyState.active);
	}

	private setStateArchived(): void {
		this.setState(CompanyState.archived);
	}

	private setState(requestedState: CompanyState): void {
		if (this.company === null) return;

		const confirm = this.$refs.confirm as unknown as AsiConfirmDialog;
		confirm.openDialog().then((res: boolean) => {
			if (!res || this.company === null) return;
			this.loading = true;
			this.$companyService.state(this.company.id, requestedState)
				.then(() => {
					this.loadCompany();
				})
				.catch(() => {
					this.$store.commit('ui/showSnackbar', {
						message: this.$t('snackbar.updateError'),
						color: 'error',
					} as SnackbarMessage);
				})
				.finally(() => {
					this.loading = false;
				});
		});
	}

	private deleteCompany(): void {
		if (this.company === null || this.company.hasReports) return;

		const confirm = this.$refs.confirm as unknown as AsiConfirmDialog;
		confirm.openDialog().then((res: boolean) => {
			if (!res || this.company === null) return;

			this.loading = true;
			this.$companyService.delete(this.company.id)
				.then(() => {
					this.$router.push({name: 'Companies'})
				})
				.catch(() => {
					this.$store.commit('ui/showSnackbar', {
						message: this.$t('snackbar.deleteError'),
						color: 'error',
					} as SnackbarMessage);
				})
				.finally(() => {
					this.loading = false;
				});
		});
	}

}
